if (!customElements.get("description-tab")) {
  customElements.define(
    "description-tab",
    class DescriptionTab extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.headers = this.querySelectorAll(".description-header");
        this.headers.forEach((header) => {
          header.addEventListener("click", this.toggleDesc.bind(this, header));
        });
        // specifically for fit notes description tab
        this.fitNotesTab = this.querySelector(".description-content[data-type='fit-notes']");
        this.descTab = this.querySelector(".description-content[data-type='desc']");
        // Open the fitNotesTab in desktop when first load.
        // Get width and height of the window excluding scrollbars
        var w = document.documentElement.clientWidth;

        if (this.fitNotesTab) {
          if (w > 990) {
            this.fitNotesTab.parentNode
              .querySelector(".description-header")
              .classList.add("opened");
            this.fitNotesTab.parentNode.setAttribute("open", "");
            this.fitNotesTab.style.maxHeight = this.fitNotesTab.scrollHeight + "px";
          }
        } else if (this.descTab) {
          if (w > 990) {
            this.descTab.parentNode.querySelector(".description-header").classList.add("opened");
            this.descTab.parentNode.setAttribute("open", "");
            this.descTab.style.maxHeight = this.descTab.scrollHeight + "px";
          }
        }

        // Attaching the event listener function to window's resize event
        window.addEventListener("resize", this.closeWhenScreen990.bind(this));
      }

      toggleDesc(headerElm) {
        headerElm.classList.toggle("opened");

        // const content = headerElm
        //   .closest(".description--wrapper")
        //   .querySelector(".description-content");

        // if (content.style.maxHeight) {
        //   content.style.maxHeight = null;
        // } else {
        //   content.style.maxHeight = content.scrollHeight + "px";
        // }
      }

      closeWhenScreen990() {
        // Get width and height of the window excluding scrollbars
        var w = document.documentElement.clientWidth;

        if (w <= 990) {
          this.headers.forEach((header) => {
            header.classList.remove("opened");
            // const content = header
            //   .closest(".description--wrapper")
            //   .querySelector(".description-content");

            // if (content.style.maxHeight) {
            //   content.style.maxHeight = null;
            // }
          });
        } else {
          this.headers[0].classList.add("opened");
          // const content = this.headers[0]
          //   .closest(".description--wrapper")
          //   .querySelector(".description-content");
          // content.style.maxHeight = content.scrollHeight + "px";
        }
      }
    }
  );
}
